module.exports = __webpack_public_path__ + "static/img/14.daeb1be1.png";